/** @format */

import { createSelector } from '@ngrx/store';
import { selectProductReviewState } from './product-reviews.selector';

/**
 * @description
 * Handles selecting the pros of the product reviews
 * It filters out the duplicate cons in case the BV's API returns duplicates.
 */
export const selectProductReviewPros = createSelector(selectProductReviewState, (state) => {
	if (Array.isArray(state.productReviewsProsConsState?.pros)) {
		const unique = new Set();
		return state.productReviewsProsConsState.pros.filter((pro) => {
			if (unique.has(pro.feature)) {
				return false;
			}
			unique.add(pro.feature);
			return true;
		})
		.sort((a, b) => b.reviewsMentioned.total - a.reviewsMentioned.total);
	}
	return [];
});


/**
 * @description
 * Handles selecting the cons of the product reviews.
 * It filters out the duplicate cons in case the BV's API returns duplicates.
 */
export const selectProductReviewCons = createSelector(selectProductReviewState, (state) => {
	if (Array.isArray(state.productReviewsProsConsState.cons)) {
		const unique = new Set();
		return state.productReviewsProsConsState.cons.filter((con) => {
			if (unique.has(con.feature)) {
				return false;
			}
			unique.add(con.feature);
			return true;
		})
		.sort((a, b) => b.reviewsMentioned.total - a.reviewsMentioned.total);
	}
	return [];
});

/**
 * @description Selects the first 3 highly rated features
 */
export const selectHighlyRatedFeatures = createSelector(
  selectProductReviewPros,
  (pros) => {
    if (!Array.isArray(pros)) {
      return [];
    }
    return pros.slice(0, 3);
  }
);


/**
 * @description Returns the selected feature
 */
export const selectSelectedFeature = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsProsConsState.selectedFeature
);
